import { ASSET_PREFIX } from "utils/constants";

const PrizeOption = ({ prizeOption, onClick, selected }) => (
  <div className='card' onClick={onClick}>
    <div style={{ position: 'relative' }}>
      <img src={`${ASSET_PREFIX}/images/radio-button${selected ? '-checked' : ''}.svg`} style={{ cursor: 'pointer' }} className='checkbox' />
    </div>
    <img src={prizeOption.imageLocation} className='thumbnail' />

    <div className='textContainer'>
      <p style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
        {prizeOption.title}
      </p>

      <p style={{ fontStyle: 'italic', fontSize: '1.2em' }}>
        {prizeOption.subheading}
      </p>
    </div>

    <style jsx>{`
      .card {
        display: flex;
        box-shadow: 2px 2px 12px rgba(55,55,55,0.6);
        border-radius: 3px;
        overflow: hidden;
        margin: 1em;
        width: 100%;
        flex-shrink: 0;
        cursor: pointer;
      }
      
      .checkbox {
        position: absolute;
        width: 30px;
        height: 30px;
        left: 8px;
        top: 8px;
      }
      
      .textContainer {
        padding 2em;
        margin: auto 1em;
        width: 100%;
      }
      
      .separator {
        width: 80%;
        height: 2.5px;
        margin: 1em 0;
      }
      
      .thumbnail {
        width: 35%;
        max-width: 150px;
        height: 100%;
      }
      
      @media(max-width: 420px) {
        .textContainer {
          padding: 1em;
        }
        
        .separator {
          margin: 0.5em 0;
        }
        
        p {
          margin: 0;
        }
      }
    `}</style>
  </div>
);

export default PrizeOption;